/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { LoadExportConfigurationsMutationResponse } from "../types/LoadExportConfigurations.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const loadExportConfigurationsMutationKey = () =>
  [{ url: "/v1/export/load-export-configurations" }] as const

export type LoadExportConfigurationsMutationKey = ReturnType<
  typeof loadExportConfigurationsMutationKey
>

/**
 * @summary Load export configurations
 * {@link /v1/export/load-export-configurations}
 */
export async function loadExportConfigurations(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    LoadExportConfigurationsMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "POST",
    url: `/v1/export/load-export-configurations`,
    ...requestConfig,
  })
  return res
}

export function loadExportConfigurationsMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const mutationKey = loadExportConfigurationsMutationKey()
  return mutationOptions<
    ResponseConfig<LoadExportConfigurationsMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >({
    mutationKey,
    mutationFn: async () => {
      return loadExportConfigurations(config)
    },
  })
}

/**
 * @summary Load export configurations
 * {@link /v1/export/load-export-configurations}
 */
export function useLoadExportConfigurations<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<LoadExportConfigurationsMutationResponse>,
      ResponseErrorConfig<Error>,
      void,
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? loadExportConfigurationsMutationKey()

  const baseOptions = loadExportConfigurationsMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<LoadExportConfigurationsMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >

  return useMutation<
    ResponseConfig<LoadExportConfigurationsMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<LoadExportConfigurationsMutationResponse>,
    ResponseErrorConfig<Error>,
    void,
    TContext
  >
}
